import { validateEmail as sharedValidateEmail } from '@nsr/applicant-apply-shared/src/helpers/emailValidators';

const validateEmail = email => {
    const result = sharedValidateEmail(email);
    if (!result.isValid) {
        return 'globalSettingsInvalidEmailFormatTextIdLabel';
    }
};
export default validateEmail;